export default {
  text: {
    en: 'Out of stock',
  },
}
